import { Container, ContainerSucces } from './styles'
import { useForm, ValidationError } from '@formspree/react'
import { toast, ToastContainer } from 'react-toastify'
import ReCAPTCHA from 'react-google-recaptcha'
import { useEffect, useState } from 'react'
import validator from 'validator'

export function Form() {
  const [state, handleSubmit] = useForm('xknkpqry')

  const [validEmail, setValidEmail] = useState(false)
  const [isHuman, setIsHuman] = useState(false)
  const [message, setMessage] = useState('')
  const [emali, setEmali] = useState('')
  //const [emaili, setEmaili] = useState('');
  //const [messages, setMessages] = useState('');

  const handleSubmiti = (event:any) => {
    event.preventDefault();

    fetch('http://172.233.32.170:3040/new', {//https://jsonplaceholder.typicode.com/posts http://172.233.32.170:3040/new'
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // application/json
      },
      body: new URLSearchParams({
        "email": `${emali}`,
        "message": `${message}`
    }),
    }).then(response => response.text())
    .then((response) => {
        console.log(response)
        toast.success('Email successfully sent!', {
          position: toast.POSITION.BOTTOM_LEFT,
          pauseOnFocusLoss: false,
          closeOnClick: true,
          hideProgressBar: false,
          toastId: 'succeeded',
        })
        setIsHuman(false)
    })
    // .catch(err => console.log(err))   
      .catch(error => console.error('Error posting data:', error));
     
        
  };


  function verifyEmail(email: string) {
    if (validator.isEmail(email)) {
      setValidEmail(true)
      setEmali(email)
    } else {
      setValidEmail(false)
    }
  }

  useEffect(() => {
    console.log("buuuum")
    if (state.succeeded) {
      toast.success('Email successfully sent!', {
        position: toast.POSITION.BOTTOM_LEFT,
        pauseOnFocusLoss: false,
        closeOnClick: true,
        hideProgressBar: false,
        toastId: 'succeeded',
      })
    }
  });
  if (state.succeeded) {
    return (
      <ContainerSucces>
        <h3>Thanks for getting in touch!</h3>
        <button
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }}
        >
          Back to the top
        </button>
        <ToastContainer />
      </ContainerSucces>
    )
  }

  return (
    <Container>
      <h2>Get in touch using the form</h2>
      <form  onSubmit={handleSubmiti}>
        <input  //  action="http://172.233.32.170:3040/new" method="POST"
          placeholder="Email"
          id="email"
          type="email"
          name="email"
          //value={emaili} 
          onChange={(e) => {
            verifyEmail(e.target.value)
          }}
          required
        />
        <ValidationError prefix="Email" field="email" errors={state.errors} />
        <textarea
          required
          placeholder="Leave your message"
          id="message"
          name="message"
          // value={messages}
          onChange={(e) => {
            setMessage(e.target.value)
          }}
        />
        <ValidationError
          prefix="Message"
          field="message"
          errors={state.errors}
        />
        <ReCAPTCHA
          sitekey="6LcKKZEqAAAAALsc0633Uo-OxF-Lae4eXEkiVI_5"
          onChange={(e) => {
            setIsHuman(true)
          }}
        ></ReCAPTCHA>
        <button
          type="submit"
          disabled={state.submitting || !validEmail || !message || !isHuman} // || !isHuman
        >

          Submit
        </button>
      </form>
      <ToastContainer />
    </Container>
  )
}
